import React from "react";
import { useTranslation } from "react-i18next";
import get from "lodash/get";
import includes from "lodash/includes";

const PlanTile = (props) => {
  const { type, user, momentTZ } = props;
  const { t } = useTranslation("dashboard");

  if (includes(["admin", "ambassador", "coach", "trial"], type)) {
    const planClassMap = {
      admin: "Administrator",
      ambassador: "Ambassador",
      coach: "Coach",
      trial: "Trial",
    };
    const planClassName = planClassMap[type] || "Trial";

    const labelKeyMap = {
      admin: "administrator",
      ambassador: "ambassador",
      coach: "coach",
      trial: "trial",
    };
    const accountTypeLabel = t(`planTile.${labelKeyMap[type] || "trial"}`);

    let trialEndDate;
    if (type === "trial") {
      trialEndDate = momentTZ(get(user, "stripe.trial_end"));
    }

    return (
      <div className={`tile Plan-${planClassName}`}>
        <div className="inset">
          <div className="title">
            {t("planTile.accountType")}
            <b>{accountTypeLabel}</b>
          </div>
          {type === "trial" && (
            <div>
              <p>
                {t("planTile.daysLeft", {
                  count: trialEndDate.diff(momentTZ(), "days"),
                })}
              </p>
              <a href="/dashboard/settings/subscription" className="button">
                {t("planTile.upgrade")}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (includes(["premium", "standard"], type)) {
    const periodEndDate = momentTZ(get(user, "stripe.period_end"));

    const plan = get(user, "stripe.plan");
    const billingFrequencyKey =
      {
        trial: "trialing",
        launch_oneMonth: "monthly",
        launch_threeMonth: "quarterly",
        launch_twelveMonth: "yearly",
        v2_premium_monthly: "monthly",
        v2_premium_annually: "yearly",
        v2_standard_monthly: "monthly",
        v2_standard_anually: "yearly",
      }[plan] || "";
    const billingFrequencyString = billingFrequencyKey
      ? t(`planTile.${billingFrequencyKey}`)
      : "";

    return (
      <div className="Plan-Premium tile">
        {user.cancelled ? (
          <div className="status cancelled">
            <b>{t("planTile.subscriptionCancelled")}</b>{" "}
            {t("planTile.activeUntil", {
              date: periodEndDate.format("MMM. DD, YYYY"),
            })}
          </div>
        ) : (
          <div className="status">
            {t("planTile.renewalDate")}{" "}
            <b>
              {periodEndDate.format("MMM. DD, YYYY")} ({billingFrequencyString})
            </b>
          </div>
        )}
        <div className="inset">
          <div className="title">
            {t("planTile.currentPlan")}
            <b>
              {type === "premium"
                ? t("planTile.premium")
                : t("planTile.standard")}
            </b>
          </div>
          <p>{t("planTile.manageAccount")}</p>
          <a href="/dashboard/settings" className="text-button icon">
            <img src="/img/svg/icon_edit_white.svg" alt="icon" />
            {t("planTile.settings")}
          </a>
        </div>
      </div>
    );
  }
};

export default PlanTile;
